import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import GenericTable from '../../../../shared/GenericTable';
import { GuestUserCategoryPoint } from '../../guestUserStatsFormat';
import { dashboardSummaryTableDefaults } from '../../dashboardReportTableConfig';

type GuestUsersBreakdownListProps = {
    points: GuestUserCategoryPoint[];
    categoryLabel: string;
};

type BreakdownRow = GuestUserCategoryPoint & { id: number };

export default function GuestUsersBreakdownList({
    points,
    categoryLabel,
}: GuestUsersBreakdownListProps) {
    const columns: MRT_ColumnDef<BreakdownRow>[] = useMemo(
        () => [
            {
                accessorKey: 'label',
                header: categoryLabel,
                size: 180,
            },
            {
                accessorKey: 'count',
                header: 'Users',
                size: 120,
            },
        ],
        [categoryLabel],
    );

    const rows = useMemo(
        () =>
            (points ?? []).map((point, index) => ({
                id: index + 1,
                ...point,
            })),
        [points],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No guest user breakdown found.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardSummaryTableDefaults}
                columns={columns}
                data={rows}
                tableName='Guest Users Breakdown'
            />
        </Box>
    );
}
